import React, { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Link } from "react-router-dom";
import authService from '../api-authorization/AuthorizeService'
import moment from 'moment';
import * as PropTypes from "prop-types";
import {HelpText} from "../HelpText";
import SimpleBackdrop from "../backdrop";
import Box from "@mui/material/Box";
import RandomQuote from "../randomQuote";
import {DataGrid} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import HelpCenter from "./HelpCenter";

export default function HelpDisplay({updateTitle}) {

    return (
        <div>

<HelpCenter />

        </div>
    );

}
